module.exports = __webpack_public_path__ + "static/submit-grad-ba-8db0cc67508c37ab10b9070fce683569.png";